import React, { useEffect } from "react";
import {
  Box,
  Divider,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import CustomText from "components/common/CustomText/CustomText";
import { colors } from "styles/colors";
import { useFormContext } from "react-hook-form";
import { FieldsType } from "types/types";
import DeleteIcon from "icons/DeleteIcon";

export default function RegistryFields() {

  const [originalFields, setOriginalFields] = React.useState<any[]>([
    {
      property: 'Patient first name',
      type: FieldsType.Free_Text,
      name: 'patient_first_name',
      visible: true,
      required: true
    },
    {
      property: 'Patient last name ',
      type: FieldsType.Free_Text,
      name: 'patient_last_name',
      visible: true,
      required: true
    },
    {
      property: 'Gender ',
      type: FieldsType.Drop_down_list,
      name: 'gender',
      visible: true,
      required: true
    },
    {
      property: 'Procedure/Test type ',
      type: FieldsType.Free_Text,
      name: 'type',
      visible: true,
      required: false
    },
    {
      property: 'Procedure/Test date ',
      type: FieldsType.Date,
      name: 'date',
      visible: true,
      required: false
    },
    {
      property: 'Institute',
      type: FieldsType.Drop_down_list,
      name: 'institute',
      visible: true,
      required: false
    },
    {
      property: 'Date of birth ',
      type: FieldsType.Date,
      name: 'date_of_birth',
      visible: true,
      required: false
    },
    {
      name: 'mrn',
      type: FieldsType.Free_Text,
      required: false,
      visible: true,
      property: 'Medical record number'
    },
    {
      name: 'insurance',
      type: FieldsType.Free_Text,
      required: false,
      visible: true,
      property: 'Insurance'
    },
    {
      name: 'diagnosisCodes',
      type: FieldsType.Diagnosis,
      required: false,
      visible: true,
      property: 'Diagnosis (ICD-9/10)'
    },
    {
      name: 'cptCodes',
      type: FieldsType.Cpt,
      required: false,
      visible: true,
      property: 'CPT Code'
    },
    {
      name: 'role',
      type: FieldsType.Drop_down_list,
      required: false,
      visible: true,
      property: 'Role'
    },
    {
      name: 'vendors',
      type: FieldsType.Free_Text,
      required: false,
      visible: true,
      property: 'Vendors'
    },
    {
      name: 'findings',
      type: FieldsType.Free_Text,
      required: false,
      visible: true,
      property: 'Findings'
    },
    {
      name: 'complications',
      type: FieldsType.Free_Text,
      required: false,
      visible: true,
      property: 'Complications'
    },
    {
      name: 'outcome',
      type: FieldsType.Free_Text,
      required: false,
      visible: true,
      property: 'Outcome'
    },

    {
      name: 'notes',
      type: FieldsType.Array,
      required: false,
      visible: true,
      property: 'Notes'
    },
    {
      name: 'images',
      type: FieldsType.Image,
      required: false,
      visible: true,
      property: 'Images'
    }
  ]);

  const {
    setValue,
  } = useFormContext();

  useEffect(() => {
    setValue('fields', originalFields);
  }, [originalFields])

  const removeField = (fieldName: string) => {
    setOriginalFields(prev => prev.filter(f => f.name !== fieldName));
  }

  return (
    <Box
      sx={{
        flex: 1,
        border: `1px solid ${colors.secondary}`,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden"
      }}
    >
      <Box p={2}>
        <CustomText
          text='Original case fields'
          fontSize={16}
          fontWeight={600}
        />
      </Box>

      <Divider />

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0
        }}
      >
        <TableContainer
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "auto"
          }}>
          <Table stickyHeader sx={{ minWidth: 600 }}>
            <TableHead>
              <TableRow>
                <TableCell>Field name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Visible to others</TableCell>
                <TableCell>Required</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {originalFields.map((row, index) => (
                <TableRow key={row.name}>
                  <TableCell>{row.property}</TableCell>
                  <TableCell>{row.type}</TableCell>
                  <TableCell>{row.visible ? 'Yes' : 'No'}</TableCell>
                  <TableCell>{row.required ? 'Yes' : 'No'}</TableCell>
                  <TableCell>{index > 4 && (
                    <Tooltip title='Remove'>
                      <IconButton onClick={() => removeField(row.name)}>
                        <DeleteIcon color={colors.error} />
                      </IconButton>
                    </Tooltip>
                  )}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}